import { Appearance, DraftConfiguration, PrintArea } from '@/types';
import { getAdjustedScaleAndOffset } from '@/model/configuration/getAdjustedScaleAndOffset';
import { getPossiblePrintTypes } from '@/model/configuration/getPossiblePrintTypes';
import { isDraftTextConfiguration } from '@/model/configuration/isDraftConfigurationType';
import { changePrintType } from './changePrintType';
import { resizeTextToScale } from './resizeTextToScale';

export const setPrintAreaOfConfiguration = (
  configuration: DraftConfiguration,
  appearance: Appearance,
  newPrintArea: PrintArea
) => {
  const possiblePrintTypes = getPossiblePrintTypes(configuration, newPrintArea, appearance);
  const printType =
    possiblePrintTypes.find((p) => p.id === configuration.printType.id) || possiblePrintTypes[0];

  if (!printType) {
    return;
  }

  const [scale, offset] = getAdjustedScaleAndOffset(configuration, newPrintArea, printType);

  if (isDraftTextConfiguration(configuration)) {
    resizeTextToScale(configuration, newPrintArea, printType, scale);
    configuration.offset = offset;
  } else {
    configuration.offset = offset;
    configuration.scale = scale;
  }

  configuration.printArea = newPrintArea;
  changePrintType(configuration, printType, false);
};
